import React, { Component } from "react";
import { Route, Switch, Link } from "react-router-dom";
import { Manager, Target, Popper, Arrow } from "react-popper";
import { Cover } from "./Cover";
import { Register } from "./Register";
import TestPage from "./TestPage";
import SubSectionTestPage from "./SubSectionTestPage";
import FullTestPage from "./FullTestPage";
// import { ResultCover } from './ResultCover'
import ThankYouPage from "./ThankYouPage";
import Report from "./Report";
import { FullPageReport } from "./FullPageReport";
import { LoadCase } from "./LoadCase";
import { NotFound } from "./NotFound";
import * as Session from "./session";
import Logo from "./banner.jpg";
import * as Questions from "./questions";
import { PreRegisterPage2 } from "./PreRegister2";

export const App = () => (
  <div className="h-100">
    <Switch>
      <Route exact path="/" render={() => <Cover />} />
      <Route exact path="/cover" render={() => <Cover />} />
      <Route exact path="/register" component={MainWithHeader} />
      <Route exact path="/preregister" component={MainWithHeader} />
      <Route
        exact
        path="/preregister/complete/:userEmail"
        component={MainWithHeader}
      />
      <Route path="/user/:userEmail" component={MainWithHeader} />
      <Route
        exact
        path="/report/:userEmail"
        render={props => <FullPageReport {...props} />}
      />

      {/* <Route exact path='/resultcover' component={ResultCover} /> */}
    </Switch>
  </div>
);

const MainWithHeader = props => (
  <div className="h-100">
    <Header style={{ marginBottom: "1em" }} />
    <Main style={{ marginTop: "5em", overflowY: "scroll" }} />
    <Footer />
  </div>
);

const Header = props => (
  <nav
    className="navbar fixed-top navbar-expand-lg navbar-light bg-light"
    {...props}
    style={{ backgroundColor: "#e3f2fd", borderBottom: "thin solid #eee" }}
  >
    <a className="navbar-brand">
      <img src={Logo} height="40" style={{ borderRadius: "0.25em" }} />
    </a>
    <span className="mx-auto">
      <Route
        exact
        path="/user/:userEmail/section/:sectionOffset/subsection/:subSectionOffset"
        component={TrackerTop}
      />
    </span>
    <small className="navbar-text ml-auto text-right">
      <small>Ferramenta de Auto-Diagnóstico</small>
    </small>
  </nav>
);

const TrackerTop = props => {
  let {
    userEmail,
    sectorId,
    sectionOffset,
    subSectionOffset
  } = props.match.params;
  if (sectorId) Session.updateSectorIfRequired(sectorId);
  let responseTree = Session.currentSession.responses;
  if (!responseTree) return null;
  let section = responseTree.sections[sectionOffset];
  let subSection = section.subSections[subSectionOffset];
  let totalNumberOfSubSections = Questions.numberOfSubSectionsInTree(
    responseTree
  );
  let cursor = {
    sectionOffset: parseInt(sectionOffset),
    subSectionOffset: parseInt(subSectionOffset)
  };
  let absoluteOffsetForCursor = Questions.absoluteSubSectionOffsetForSubSectionWithCursorInTree(
    cursor,
    responseTree
  );
  return (
    <span>
      <small className="text-muted">
        <small>Secção</small>
      </small>
      <span style={{ marginRight: "0.25em" }} />
      <span className="alert alert-primary" style={{ padding: ".4rem 0.5rem" }}>
        {section.title}
      </span>
      <span style={{ marginRight: "1em" }} />
      <small className="text-muted">
        <small>SubSecção</small>
      </small>
      <span style={{ marginRight: "0.25em" }} />
      <span className="alert alert-success" style={{ padding: ".4rem 0.5rem" }}>
        {subSection.title && <span>{subSection.title}</span>}
      </span>
    </span>
  );
};

const TrackerBottom = props => {
  let {
    userEmail,
    sectorId,
    sectionOffset,
    subSectionOffset
  } = props.match.params;
  if (sectorId) Session.updateSectorIfRequired(sectorId);
  let responseTree = Session.currentSession.responses;
  if (!responseTree) return null;
  let section = responseTree.sections[sectionOffset];
  let subSection = section.subSections[subSectionOffset];
  let totalNumberOfSubSections = Questions.numberOfSubSectionsInTree(
    responseTree
  );
  let cursor = {
    sectionOffset: parseInt(sectionOffset),
    subSectionOffset: parseInt(subSectionOffset)
  };
  let absoluteOffsetForCursor = Questions.absoluteSubSectionOffsetForSubSectionWithCursorInTree(
    cursor,
    responseTree
  );
  return (
    <small className="text-muted">
      Página <span className="text-primary">{absoluteOffsetForCursor + 1}</span>{" "}
      de <span className="text-primary">{totalNumberOfSubSections}</span>
      {totalNumberOfSubSections - absoluteOffsetForCursor - 1 > 0 && (
        <span>
          &nbsp;&mdash;&nbsp; Faltam{" "}
          <span className="text-primary">
            {totalNumberOfSubSections - absoluteOffsetForCursor - 1}
          </span>{" "}
          para concluir
        </span>
      )}
    </small>
  );
};

const Main = props => {
  return (
    <main className="container" {...props}>
      <Switch>
        {/* Routes used in production */}
        <Route exact path="/register" component={Register} />
        <Route exact path="/preregister" component={PreRegisterPage2} />
        <Route
          exact
          path="/user/:userEmail"
          render={props => <LoadCase {...props} />}
        />
        <Route
          exact
          path="/user/:userEmail/notfound"
          render={props => <NotFound {...props} />}
        />
        <Route
          exact
          path="/user/:userEmail/section/:sectionOffset/subsection/:subSectionOffset/"
          render={props => <SubSectionTestPage {...props} />}
        />
        <Route
          exact
          path="/user/:userEmail/full"
          render={props => <FullTestPage {...props} />}
        />
        <Route
          exact
          path="/user/:userEmail/thanks"
          render={props => <ThankYouPage {...props} />}
        />
        <Route
          exact
          path="/user/:userEmail/report"
          render={props => <Report {...props} />}
        />

        {/* Routes for developing and testing purposes*/}
        {/* <Route exact path='/sector/:sectorId/section/:sectionOffset/subsection/:subSectionOffset/' render={ (props) => <SubSectionTestPage {...props} />}/> */}
        {/* <Route exact path='/sector/:sectorId/full' render={ (props) => <FullTestPage {...props} />}/> */}
      </Switch>
    </main>
  );
};

const Footer = props => (
  <footer
    className="fixed-bottom bg-light"
    style={{ borderTop: "thin solid #eee", padding: "0.25em" }}
  >
    <div className="float-right small">
      <span className="ml-auto">
        <Route
          exact
          path="/user/:userEmail/section/:sectionOffset/subsection/:subSectionOffset"
          component={TrackerBottom}
        />
      </span>
    </div>
    <div className="container small text-info mx-auto text-center">
      <Route
        path="/user/:userEmail/section/:sectionOffset/subsection/:subSectionOffset"
        component={SurveyLink}
      />
    </div>
  </footer>
);

const BASE_URL = "https://leziria-sustentavel.nersant.pt";

class SurveyLink extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _showPopover: false
    };
  }

  toggle() {
    this.setState({
      _showPopover: !this.state._showPopover
    });
  }

  render() {
    return (
      <Manager>
        <Target>
          {({ targetProps }) => (
            <div {...targetProps} onClick={this.toggle.bind(this)}>
              Retomar mais tarde?
            </div>
          )}
        </Target>
        {this.state._showPopover && (
          <Popper
            placement="top"
            modifiers={{ preventOverflow: { enabled: true } }}
          >
            {({ popperProps, restProps }) => (
              <div
                className="card"
                {...popperProps}
                style={{ ...popperProps.style }}
              >
                <div className="card-header text-secondary text-center">
                  <button
                    type="button"
                    className="close"
                    aria-label="Close"
                    onClick={this.toggle.bind(this)}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  Retomar mais tarde
                </div>
                <div className="card-body text-secondary">
                  Tome o seu tempo. Pode retomar o teste, quando quiser, em:
                  <br />
                  <a
                    className="text-primary"
                    href={`${BASE_URL}/user/${
                      Session.currentSession.contactEmail
                    }`}
                  >{`${BASE_URL}/user/${
                    Session.currentSession.contactEmail
                  }`}</a>
                </div>
                <Arrow>
                  {({ arrowProps, restProps }) => (
                    <span className="popper__arrow" {...arrowProps} />
                  )}
                </Arrow>
              </div>
            )}
          </Popper>
        )}
      </Manager>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.jsx